import { render, staticRenderFns } from "./ClaimForm.vue?vue&type=template&id=f4766cc8&scoped=true"
import script from "./ClaimForm.vue?vue&type=script&lang=ts"
export * from "./ClaimForm.vue?vue&type=script&lang=ts"
import style0 from "./ClaimForm.vue?vue&type=style&index=0&id=f4766cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4766cc8",
  null
  
)

export default component.exports